import React from 'react'
import "./footer.css"
export const Footer = () => {
  return (
    <footer className="footer">
      &copy;  ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლა. All rights reserved.
    </footer>
  )
}
